import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/ui/docs-site/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
/*-- dri: Alexa Kreizinger --*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "S3 Input (One Time) source plugin (Telemetry Pipeline)";
const frontMatter = {
  "title": "S3 Input (One Time) source plugin (Telemetry Pipeline)",
  "description": "Receive pipeline data from Amazon S3."
};
import {Icon} from '@/components';
import {mdiCancel, mdiCheckCircle} from '@mdi/js';
import PipelineFlow, {useTOC as useTOC0} from '@/_partials/pipeline-flow-source.mdx';
import PluginDuplicates, {useTOC as useTOC1} from '@/_partials/plugin-duplicates.mdx';
export function useTOC(props) {
  return [...useTOC0(), ...useTOC1(), {
    value: "Supported telemetry types",
    id: "supported-telemetry-types",
    depth: 2
  }, {
    value: "Configuration parameters",
    id: "configuration-parameters",
    depth: 2
  }, {
    value: "Required",
    id: "required",
    depth: 3
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    p: "p",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ..._provideComponents(),
    ...props.components
  };
  return <>{}{"\n"}<_components.h1>{"S3 Input (One Time) source plugin"}</_components.h1>{"\n"}<PipelineFlow />{"\n"}<_components.p>{"The S3 Input (One Time) source plugin lets you retrieve data from your Amazon S3\nbuckets and ingest it into Chronosphere Telemetry Pipeline."}</_components.p>{"\n"}<PluginDuplicates />{"\n"}<_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<_components.p>{"This plugin supports these telemetry types:"}</_components.p>{"\n"}<_components.table><_components.thead><_components.tr><_components.th style={{
    textAlign: "center"
  }}>{"Logs"}</_components.th><_components.th style={{
    textAlign: "center"
  }}>{"Metrics"}</_components.th><_components.th style={{
    textAlign: "center"
  }}>{"Traces"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td style={{
    textAlign: "center"
  }}><Icon path={mdiCheckCircle} style={{
    color: 'rgb(89, 204, 141)'
  }} aria-label={"Yes"} /></_components.td><_components.td style={{
    textAlign: "center"
  }}><Icon path={mdiCancel} style={{
    color: 'rgb(234, 71, 71)'
  }} aria-label={"No"} /></_components.td><_components.td style={{
    textAlign: "center"
  }}><Icon path={mdiCancel} style={{
    color: 'rgb(234, 71, 71)'
  }} aria-label={"No"} /></_components.td></_components.tr></_components.tbody></_components.table>{"\n"}<_components.h2 id={toc[1].id}>{toc[1].value}</_components.h2>{"\n"}<_components.p>{"Use the parameters in this section to configure your plugin. The Telemetry Pipeline\nweb interface uses the values in the "}<_components.strong>{"Name"}</_components.strong>{" column to describe the parameters.\nItems in the "}<_components.strong>{"Key"}</_components.strong>{" column are the YAML keys to use in\n"}<_components.a href="/pipeline-configure/config-files">{"pipeline configuration files"}</_components.a>{"."}</_components.p>{"\n"}<_components.h3 id={toc[2].id}>{toc[2].value}</_components.h3>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Name"}</_components.th><_components.th>{"Key"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Default"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td><_components.strong>{"AWS Access Key"}</_components.strong></_components.td><_components.td><_components.code>{"aws_access_key"}</_components.code></_components.td><_components.td>{"Required. Your AWS access key path."}</_components.td><_components.td><_components.em>{"none"}</_components.em></_components.td></_components.tr><_components.tr><_components.td><_components.strong>{"AWS Secret Key"}</_components.strong></_components.td><_components.td><_components.code>{"aws_secret_key"}</_components.code></_components.td><_components.td>{"Required. Your AWS secret key path."}</_components.td><_components.td><_components.em>{"none"}</_components.em></_components.td></_components.tr><_components.tr><_components.td><_components.strong>{"AWS Bucket Name"}</_components.strong></_components.td><_components.td><_components.code>{"aws_bucket_name"}</_components.code></_components.td><_components.td>{"Required. The name of the S3 bucket where logs are stored. For example: "}<_components.code>{"logs"}</_components.code>{"."}</_components.td><_components.td><_components.em>{"none"}</_components.em></_components.td></_components.tr><_components.tr><_components.td><_components.strong>{"AWS Bucket Region"}</_components.strong></_components.td><_components.td><_components.code>{"aws_bucket_region"}</_components.code></_components.td><_components.td>{"Required. The name of the AWS region associated with your S3 bucket. For example: "}<_components.code>{"us-east1"}</_components.code>{"."}</_components.td><_components.td><_components.em>{"none"}</_components.em></_components.td></_components.tr><_components.tr><_components.td><_components.strong>{"File Path"}</_components.strong></_components.td><_components.td><_components.code>{"logs"}</_components.code></_components.td><_components.td>{"Required. Glob format of the logs inside your S3 bucket. For example: "}<_components.code>{"/logs/\\*.log"}</_components.code>{"."}</_components.td><_components.td><_components.em>{"none"}</_components.em></_components.td></_components.tr></_components.tbody></_components.table></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/pipeline-data/plugins/source-plugins/amazon-s3',
  {"filePath":"pages/pipeline-data/plugins/source-plugins/amazon-s3.mdx",pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)